import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de0f4fbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 mb-4" }
const _hoisted_4 = { class: "subtitle" }
const _hoisted_5 = { class: "row row-pharmacy" }
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = { class: "row row-email-settings align-items-center" }
const _hoisted_8 = { class: "col-auto" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-auto" }, " Email settings ", -1))
const _hoisted_10 = {
  key: 0,
  class: "col-auto"
}
const _hoisted_11 = { class: "row row-email-settings" }
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = { class: "row mb-3" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "row mb-3" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "subtitle" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "row mb-3" }
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = { class: "subtitle" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "row mb-3" }
const _hoisted_28 = { class: "col-12" }
const _hoisted_29 = { class: "subtitle" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_AdvancedPanelSwitcher = _resolveComponent("AdvancedPanelSwitcher")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_AdvancedPanel = _resolveComponent("AdvancedPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseSpinner, {
      spin: !this.isReady
    }, null, 8, ["spin"]),
    (this.isReady)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('pharmacy')), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_InputSelect, {
                    modelValue: this.contentBlock.pharmacy_code,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((this.contentBlock.pharmacy_code) = $event)),
                      this.onChange
                    ],
                    options: this.pharmacyOptions,
                    name: "pharmacy",
                    selectText: _ctx.$t('selectText'),
                    rules: "required",
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "options", "selectText", "errors", "onUpdate:modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_AdvancedPanelSwitcher, {
                    class: "mb-3",
                    "is-advanced": this.isAdvancedEmailSettings,
                    errors: _ctx.errors,
                    onToggleAdvanced: this.toggleAdvancedEmailSettings
                  }, null, 8, ["is-advanced", "errors", "onToggleAdvanced"])
                ]),
                _hoisted_9,
                (this.isAdvancedEmailSettings)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-danger btn-sm mb-3",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearEmailSettings && _ctx.clearEmailSettings(...args)))
                      }, _toDisplayString(_ctx.$t('contentClear')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_AdvancedPanel, {
                    "is-show-when-advanced": true,
                    "is-advanced": this.isAdvancedEmailSettings,
                    class: "bg-light pt-3 ms-3 mb-3 p-3 pt-4"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_InputText, {
                            modelValue: _ctx.emailSettings.subject,
                            "onUpdate:modelValue": [
                              _cache[2] || (_cache[2] = ($event: any) => ((_ctx.emailSettings.subject) = $event)),
                              _ctx.onChange
                            ],
                            name: "email_subject",
                            label: _ctx.$t('cms.email_subject'),
                            rules: _ctx.isAdvancedEmailSettings ? 'required|max:100|min:3' : '',
                            errors: _ctx.errors
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "rules", "errors"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('cms.email_to')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode(_component_InputText, {
                                modelValue: _ctx.emailSettings.to.email,
                                "onUpdate:modelValue": [
                                  _cache[3] || (_cache[3] = ($event: any) => ((_ctx.emailSettings.to.email) = $event)),
                                  _ctx.onChange
                                ],
                                name: "email_to_email",
                                label: _ctx.$t('cms.email_email'),
                                rules: _ctx.isAdvancedEmailSettings ? 'required|email|min:3' : '',
                                errors: _ctx.errors
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "rules", "errors"])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_component_InputText, {
                                modelValue: _ctx.emailSettings.to.name,
                                "onUpdate:modelValue": [
                                  _cache[4] || (_cache[4] = ($event: any) => ((_ctx.emailSettings.to.name) = $event)),
                                  _ctx.onChange
                                ],
                                name: "email_to_name",
                                label: _ctx.$t('cms.email_name'),
                                errors: _ctx.errors
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('cms.email_cc')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createVNode(_component_InputText, {
                                modelValue: _ctx.getCcEmail(),
                                name: "email_cc_email",
                                label: _ctx.$t('cms.email_email'),
                                rules: _ctx.isAdvancedEmailSettings ? 'email' : '',
                                errors: _ctx.errors,
                                "onUpdate:modelValue": _ctx.updateCcEmail
                              }, null, 8, ["modelValue", "label", "rules", "errors", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_InputText, {
                                modelValue: _ctx.getCcName(),
                                name: "email_cc_name",
                                label: _ctx.$t('cms.email_name'),
                                errors: _ctx.errors,
                                "onUpdate:modelValue": _ctx.updateCcName
                              }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('cms.email_bcc')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_component_InputText, {
                                modelValue: _ctx.getBccEmail(),
                                name: "email_bcc_email",
                                label: _ctx.$t('cms.email_email'),
                                rules: _ctx.isAdvancedEmailSettings ? 'email' : '',
                                errors: _ctx.errors,
                                "onUpdate:modelValue": _ctx.updateBccEmail
                              }, null, 8, ["modelValue", "label", "rules", "errors", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                              _createVNode(_component_InputText, {
                                modelValue: _ctx.getBccName(),
                                name: "email_bcc_name",
                                label: _ctx.$t('cms.email_name'),
                                errors: _ctx.errors,
                                "onUpdate:modelValue": _ctx.updateBccName
                              }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["is-advanced"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}